module.exports = __webpack_public_path__ + "img/apple-touch-icon.ef5ad48c.png";